var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainImgVideoHoverOffBotton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 805.281,
    height: 525.589,
    viewBox: "0 0 805.281 525.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_314",
    "data-name": "\\uADF8\\uB8F9 314",
    transform: "translate(-5424.751 -4255.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_209",
    "data-name": "\\uADF8\\uB8F9 209",
    transform: "translate(5425.75 4256.052)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_46",
    "data-name": "\\uD0C0\\uC6D0 46",
    cx: 112.744,
    cy: 20.303,
    rx: 112.744,
    ry: 20.303,
    transform: "translate(286.116 482.999) rotate(-3.892)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_151",
    "data-name": "\\uD328\\uC2A4 151",
    transform: "translate(-5422.684 -4254.259)",
    fill: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5448.2373046875 4769.091796875 L 5448.2373046875 4323.57080078125 L 6221.6416015625 4269.6884765625 L 6221.6416015625 4715.2099609375 L 5448.2373046875 4769.091796875 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5449.2373046875 4768.02001953125 L 6220.6416015625 4714.27685546875 L 6220.6416015625 4270.76025390625 L 5449.2373046875 4324.50390625 L 5449.2373046875 4768.02001953125 M 5447.2373046875 4770.1640625 L 5447.2373046875 4322.63818359375 L 6222.6416015625 4268.6162109375 L 6222.6416015625 4716.142578125 L 5447.2373046875 4770.1640625 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_152",
    "data-name": "\\uD328\\uC2A4 152",
    transform: "translate(-5417.702 -4250.698)",
    fill: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5483.15234375 4737.01220703125 L 5483.15234375 4342.38427734375 L 6176.7626953125 4294.64453125 L 6176.7626953125 4689.2724609375 L 5483.15234375 4737.01220703125 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5484.15234375 4735.94091796875 L 6175.7626953125 4688.3388671875 L 6175.7626953125 4295.7158203125 L 5484.15234375 4343.31787109375 L 5484.15234375 4735.94091796875 M 5482.15234375 4738.08349609375 L 5482.15234375 4341.45068359375 L 6177.7626953125 4293.5732421875 L 6177.7626953125 4690.2060546875 L 5482.15234375 4738.08349609375 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_153",
    "data-name": "\\uD328\\uC2A4 153",
    d: "M6225.708,4272.716l-40.43-16.664-759.528,48.272v445.119l31.361,22.514V4326.489Z",
    transform: "translate(-5425.75 -4256.052)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_154",
    "data-name": "\\uD328\\uC2A4 154",
    d: "M5780.307,4465.769l-124.044-71.617v143.233Z",
    transform: "translate(145.495 52.039)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImgVideoHoverOffBotton);
export default __webpack_public_path__ + "static/media/main_img_video_hover_off_botton.d4ff5ae6393b66f49b07bdd4365b0495.svg";
export { ForwardRef as ReactComponent };